import { Injectable, inject } from '@angular/core';

import { RestApiClientService } from '@troyai/rest-api-client';
import {
  MemberAssessmentResponse,
  MemberWithAssessmentsResponse,
} from './models/member-with-assessments-api.interface';

@Injectable({
  providedIn: 'root',
})
export class AssessmentViewerApiService {
  private restApiService = inject(RestApiClientService);

  getAllMemberAssessments() {
    return this.restApiService.get<MemberWithAssessmentsResponse[]>(`members/assessments`);
  }

  getMemberAssessments(memberGlobalId: number) {
    return this.restApiService.get<MemberAssessmentResponse[]>(
      `members/${memberGlobalId}/assessments`
    );
  }
}
